import { setCookie, getTimeZoneOffsetSeconds } from './utilities';

// need to set timezone offset value in seconds
setCookie('fcoTimeZoneOffset', getTimeZoneOffsetSeconds(), 5);
